import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { LangChangeEvent, TranslateService } from '@ngx-translate/core'
import { TermsOfUse } from '../../mocks/terms-of-use.mock'

@Component({
  selector: 'app-terms-of-use',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './terms-of-use.component.html'
})
export class TermsOfUseComponent implements OnInit {
  lang: string = this.translate.getCurrentLang()
  termsOfUse: { heading: string; content: string[] }[]

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.termsOfUse = TermsOfUse[this.translate.getCurrentLang()]
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lang = event.lang
      this.termsOfUse = TermsOfUse[event.lang]
    })
  }
}
